import {createAction, props} from '@ngrx/store';

import {AuthProviderError} from '../models/AuthProviderError.interface';

export const AuthStartedAction = createAction('[auth] started');
export const AuthSuccessAction = createAction('[auth] success', props<{token?: string; returnUrl?: string}>());
export const AuthFailureAction = createAction('[auth] failure', props<{error?: AuthProviderError}>());
